export default __webpack_public_path__ + "static/media/thumbnail.fc363ec5.webp";